import { render } from "./TelehealthIOSBase.vue?vue&type=template&id=55b8e10b&ts=true"
import script from "./TelehealthIOSBase.vue?vue&type=script&lang=ts"
export * from "./TelehealthIOSBase.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__